import styled from 'styled-components';

export const PriceStyles = styled.div`
  display: inline-block;
  .price,
  .currency {
    white-space: nowrap;
  }

  .currency {
    font-size: ${({ theme }) => theme.fontSize.nm};
  }

  &.highlighted {
    padding: 2px;
    background-color: ${({ theme }) => theme.colors.color_orange_opacity_tone5};

    &.hovered {
      background: ${({ theme }) => theme.colors.color_orange};
    }
  }
`;
